export const PUBLIC_TRANSPORT_HAFAS_API_URL =
  "https://public-transport-hafas.apps.openinc.dev";
